export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/34602365996"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white cursor-pointer transition-transform duration-300 hover:scale-110"
      style={{
        boxShadow: "0 8px 24px rgba(37,211,102,0.45)",
        animation: "waPulse 2.5s ease-in-out infinite",
      }}
    >
      <i className="ri-whatsapp-line text-3xl"></i>
      <style>{`
        @keyframes waPulse {
          0%, 100% { box-shadow: 0 8px 24px rgba(37,211,102,0.45); }
          50% { box-shadow: 0 8px 36px rgba(37,211,102,0.7), 0 0 0 8px rgba(37,211,102,0.12); }
        }
      `}</style>
    </a>
  );
}
